import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { i18n, setLocale, SUPPORTED_LOCALES, LOCALE_NAMES, type SupportedLocale } from '@/locales'

export const useLocaleStore = defineStore('locale', () => {
  const current = ref<SupportedLocale>(i18n.global.locale.value as SupportedLocale)

  const currentName = computed(() => LOCALE_NAMES[current.value])

  const availableLocales = computed(() =>
    SUPPORTED_LOCALES.map(locale => ({
      value: locale,
      label: LOCALE_NAMES[locale]
    }))
  )

  function changeLocale(locale: SupportedLocale) {
    if (!SUPPORTED_LOCALES.includes(locale)) {
      console.warn(`Unsupported locale: ${locale}`)
      return
    }

    // Update i18n and localStorage
    setLocale(locale)
    current.value = locale

    // FUTURE: Persist locale to user profile via API once the backend
    // exposes a `locale` field on the User model (PATCH /users/me { locale }).
    // This will require making changeLocale() async and calling authApi.updateProfile().
  }

  // Initialize from user profile if available
  function initFromUser(userLocale?: string | null) {
    if (userLocale && SUPPORTED_LOCALES.includes(userLocale as SupportedLocale)) {
      setLocale(userLocale as SupportedLocale)
      current.value = userLocale as SupportedLocale
    }
  }

  return {
    current,
    currentName,
    availableLocales,
    changeLocale,
    initFromUser
  }
})
